import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ContratoEntity, Steps } from './steps.models';
import { UnidadesEntity } from '@app/api/municipios/municipios.models';

@Injectable({
  providedIn: 'root',
})
export class StepsService {
  steps: Steps;

  constructor(private router: Router) {}

  setUnidade(UnidadeSelecionada: UnidadesEntity) {
    this.steps = {
      UnidadeSelecionada,
      CodigoGrupo: null,
      Grupo: null,
      CodigoModelo: null,
      Contrato: null,
      Completo: false,
      CodigoTarifaAssinatura: null,
      SubDescricao: '',
      PropostasItensEquipamento: []
    };

    localStorage.setItem('steps', JSON.stringify(this.steps));
  }

  setCodigoGrupo(CodigoGrupo: string, subdescricao: string) {
    this.steps.SubDescricao = subdescricao;
    this.steps.CodigoGrupo = CodigoGrupo;
    this.steps.Grupo = null;
    this.steps.CodigoModelo = null;
    this.steps.Completo = false;
    localStorage.setItem('steps', JSON.stringify(this.steps));
  }

  setCodigoModeloEGrupo(propostaItensEquipamento: any, CodigoTarifaAssinatura: string, CodigoModelo: string, Grupo: string) {
    this.steps.CodigoModelo = CodigoModelo;
    this.steps.PropostasItensEquipamento = propostaItensEquipamento
    this.steps.Grupo = Grupo;
    this.steps.Contrato = null;
    this.steps.Completo = false;
    this.steps.CodigoTarifaAssinatura = CodigoTarifaAssinatura;
    localStorage.setItem('steps', JSON.stringify(this.steps));
  }

  setCloseContract(Contrato: ContratoEntity) {
    this.steps.Contrato = Contrato;
    this.steps.Completo = true;
    this.steps.CodigoTarifaAssinatura = Contrato.franquia;
    localStorage.setItem('steps', JSON.stringify(this.steps));
  }

  setSteps(validarRota = false) {
    const steps = JSON.parse(localStorage.getItem('steps') ?? '{}');
    this.steps = steps;

    if (!validarRota) return;
    const currentRoute = location.pathname;
    const getBar = currentRoute.split('/');
    const lastBar = getBar[getBar.length - 1];

    if (lastBar === 'grupo-veiculo' && !this.steps.UnidadeSelecionada) {
      this.router.navigate([`${getBar[1]}/assinatura/municipio`]);
      return;
    }

    if (lastBar === 'veiculo' && !this.steps.CodigoGrupo) {
      this.router.navigate([getBar[1] + '/assinatura/grupo-veiculo']);
      return;
    }

    if (lastBar === 'contrato' && !this.steps.CodigoModelo)
      this.router.navigate([getBar[1] + '/assinatura/veiculo']);
  }

  getSteps() {
    this.setSteps();
    return this.steps ?? {};
  }

  clearSteps() {
    localStorage.removeItem('steps');
    this.steps = {
      UnidadeSelecionada: null,
      CodigoGrupo: null,
      Grupo: null,
      CodigoModelo: null,
      Contrato: null,
      Completo: false,
      CodigoTarifaAssinatura: null,
      SubDescricao: '',
      PropostasItensEquipamento: []
    };
  }
}
